<script lang="ts">
	import HomeButtonsDesktop from './HomeButtonsDesktop.svelte'
	import HomeButtonsMobile from './HomeButtonsMobile.svelte'
	// import AmericasFunniestHomeVideo from './AmericasFunniestHomeVideo.svelte'
	import { dev_mode, storefront_prefix } from 'shared/var'

	export let groups: any[]
	export let promo_active: boolean

	groups = groups.map(group => {
		for (let setname in group.sets) {
			group.sets[setname].pick = group.sets[setname].files[Math.floor(Math.random() * group.sets[setname].files.length)]
		}
		if (dev_mode) {
			group.url = group.url.replace(`https://www.trex-arms.com`, storefront_prefix)
		}
		return group
	})
</script>

<!-- AmericasFunniestHomeVideo /-->

<div class="desktop">
	<HomeButtonsDesktop {groups} {promo_active} />
</div>

<div class="mobile">
	<HomeButtonsMobile {groups} {promo_active} />
</div>

<style>
	.desktop {
		max-width: 1040px;
		overflow: hidden;
	}

	.mobile {
		display: none;
	}

	@media (max-width: 600px) {
		.desktop {
			display: none;
		}

		.mobile {
			display: block;
		}
	}
</style>
